import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
  unreadContainer: {
    marginRight: "17px",
    borderBottom: `1px solid ${theme.palette.text.tertiary}`,
    padding: "0px 12px",
    display: "flex",
    gap: "10px",
    alignItems: "center",
    "&:hover": {
      "& $originalElement": {
        visibility: "hidden",
      },
      "& $displayElement": {
        visibility: "visible",
      },
    },
    background: theme.palette.secondary.light,
  },
  readContainer: {
    marginRight: "17px",
    borderBottom: `1px solid ${theme.palette.text.tertiary}`,
    padding: "0px 12px",
    display: "flex",
    gap: "10px",
    alignItems: "center",
    "&:hover": {
      "& $originalElement": {
        visibility: "hidden",
      },
      "& $displayElement": {
        visibility: "visible",
      },
    },
  },
  notificationDrop: {
    color: theme.palette.secondary.main,
    marginLeft: "5px",
    marginRight: "5px",
    height: "20px",
    minWidth: "20px",
  },
  descriptionContainer: {
    display: "flex",
    width: "94%",
    alignItems: "center",
  },
  description: {
    color: theme.palette.text.primary,
    textAlign: "start",
    width: "85%",
    padding: "5px",
    fontFamily: "Poppins",
    fontSize: "14px",
    display: "flex",
    alignItems: "center",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  description2: {
    display: "flex",
    alignItems: "center",
  },
  thumbnail: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    fontFamily: "Poppins",
    fontSize: "12px",
  },
  singleUser: {
    display: "flex",
    alignItems: "center",
    border: `1px solid grey`,
    borderRadius: "15px",
  },
  hoverContainer: {
    width: "15%",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    position: "relative",
  },
  originalElement: {
    visibility: "visible",
    fontFamily: "Poppins",
    fontSize: "12px !important",
    color: theme.palette.text.tertiary,
    textAlign: "right",
  },
  displayElement: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    visibility: "hidden",
    position: "absolute",
    right: 0,
  },
  notdisplayElement: {
    width: "35%",
    display: "flex",
    justifyContent: "space-between",
    visibility: "hidden",
    position: "relative",
    left: 100,
  },
  iconBtn: {
    minWidth: "30px",
  },
  commentText: {
    marginLeft: "5px",
    color: theme.palette.text.tertiary,
    width: "600px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  highlightedCommentText: {
    color: "#6C65D9",
  },
}));

export default useStyles;
